/*eslint-disable*/
class NetworkService {
    handleNetworkConnection(onOnline, onOffline) {
        window.addEventListener('offline', event => {
            return onOnline();
        });

        window.addEventListener('online', event => {
            return onOffline();
        });
    }
}

export default new NetworkService()